import React from 'react';

import { FormattedMessage } from 'react-intl';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { xcss } from '@atlaskit/primitives';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- TODO: migrate to @atlaskit/primitives/compiled
import Pressable from '@atlaskit/primitives/pressable';

import { feedbackButtonMessages } from './messages';

const feedbackButtonStyles = xcss({
	backgroundColor: 'color.background.neutral.subtle',
	color: 'color.link',
	font: 'font.body',
	padding: 'space.0',
	':hover': {
		textDecoration: 'underline',
		cursor: 'pointer',
	},
});

const feedbackButtonSmallStyles = xcss({
	font: 'font.body.small',
});

type FeedbackButtonProps = {
	onClick: (e: React.KeyboardEvent | React.MouseEvent) => void;
	size?: 'small' | 'medium';
};

export const FeedbackButton = ({
	onClick,
	size = 'medium',
}: FeedbackButtonProps): React.JSX.Element => (
	<Pressable
		xcss={[feedbackButtonStyles, size === 'small' && feedbackButtonSmallStyles]}
		onClick={onClick}
	>
		<FormattedMessage {...feedbackButtonMessages.feedbackButton} />
	</Pressable>
);
